import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "tooltip", "options", "lineHeight", "onChange", "onOpenChange"];
import { LineHeightIcon, SuccessIcon } from 'foundations-assets';
import { AbstractDropdown, DropdownCaret } from 'foundations-components/transitional/components/AbstractDropdown';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'foundations-theming/utils';
import { useState } from 'react';
import { TextToolbarIcon } from '../editor/TextToolbarIcon';
// @ts-expect-error Not typed
import SimpleStyledClickable from '../editor/internal/SimpleStyledClickable';
// @ts-expect-error Not typed
import withDisabledContext from '../hoc/withDisabledContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledItemWrapper = styled.div.withConfig({
  displayName: "LineHeightMenu__StyledItemWrapper",
  componentId: "guku43-0"
})(({
  theme
}) => ({
  transition: 'background-color 150ms ease',
  color: theme.color['icon-core-default'],
  '&:hover': {
    backgroundColor: theme.color['fill-field-hover']
  }
}));
const LineHeightMenu = props => {
  const {
      disabled,
      tooltip,
      options,
      lineHeight,
      onChange,
      onOpenChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const handleOpenChange = ({
    target: {
      value
    }
  }) => {
    if (onOpenChange) {
      onOpenChange(value);
    }
    setIsOpen(value);
  };
  const handleChange = value => {
    onChange(value);
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: disabled,
    title: tooltip,
    open: isOpen ? false : undefined,
    placement: "bottom",
    children: /*#__PURE__*/_jsx(AbstractDropdown, Object.assign({}, rest, {
      menuWidth: 80,
      open: isOpen,
      disabled: disabled,
      Button: SimpleStyledClickable,
      buttonText: /*#__PURE__*/_jsx(TextToolbarIcon, {
        disabled: disabled,
        icon: LineHeightIcon,
        blockSize: "24px"
      }),
      caretRenderer: /*#__PURE__*/_jsx(DropdownCaret, {
        buttonUse: "transparent"
      }),
      onOpenChange: handleOpenChange,
      children: /*#__PURE__*/_jsx(List, {
        paddingBlock: "200",
        children: options.map(({
          text: {
            raw
          },
          value
        }) => /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(StyledItemWrapper, {
            children: /*#__PURE__*/_jsxs(Clickable, {
              inlineSize: "100%",
              paddingBlock: "200",
              paddingInline: "400",
              textAlign: "left",
              onClick: () => handleChange(value),
              children: [raw, lineHeight === value && /*#__PURE__*/_jsx(IconHolder, {
                icon: SuccessIcon,
                color: "icon-core-default",
                padding: "0",
                paddingInlineStart: "100",
                verticalAlign: "text-bottom"
              })]
            })
          })
        }, value))
      })
    }))
  });
};
export default withDisabledContext(LineHeightMenu);